import React from 'react';
import { BookOpen, Frame, Images, Layers, Link2, Palette } from 'lucide-react';
import {
  HomeIcon,
  ImageIcon,
  VideoIcon,
  BatchIcon,
  TrendForgeIcon,
  MoodboardIcon,
  BrandbookIcon,
  PackageIcon,
  GalleryIcon,
  SendIcon,
  UsersIcon,
  WorkflowIcon,
} from '../icons/Icons';
import type { MarketingIconName } from './navigation';

// Parte dos ícones não aceita className; o tamanho vem do wrapper ([&_svg]).
const ICONS: Record<MarketingIconName, React.ComponentType> = {
  home: HomeIcon,
  image: ImageIcon,
  video: VideoIcon,
  batch: BatchIcon,
  competitors: TrendForgeIcon,
  references: MoodboardIcon,
  dna: BrandbookIcon,
  products: PackageIcon,
  meta: Link2,
  ads: Layers,
  projects: GalleryIcon,
  publishing: SendIcon,
  gallery: Images,
  canvas: Frame,
  workflow: WorkflowIcon,
  lookbook: BookOpen,
  models: UsersIcon,
  brandbook: Palette,
};

const MarketingNavIcon: React.FC<{ name: MarketingIconName; className?: string }> = ({ name, className = '' }) => {
  const Icon = ICONS[name];
  return (
    <span aria-hidden className={`inline-grid place-items-center w-[18px] h-[18px] [&_svg]:w-[18px] [&_svg]:h-[18px] ${className}`}>
      <Icon />
    </span>
  );
};

export default MarketingNavIcon;
